
import { motion } from 'framer-motion';

const tiers = [
  {
    tier: 'STRATEGIC',
    name: '戦略的提携',
    investment: '$500K',
    period: '年間投資額',
    features: [
      '専任アカウントマネージャー',
      '四半期戦略レビュー',
      '優先枠確保（最大3面）',
      'リアルタイムレポーティング',
      'クリエイティブ制作サポート'
    ],
    recommended: false,
    highlight: false,
    buttonStyle: 'bg-gray-900 text-white hover:bg-gray-800'
  },
  {
    tier: 'ENTERPRISE',
    name: 'エンタープライズ',
    investment: '$2M',
    period: '年間投資額',
    features: [
      '専任チーム（3名体制）',
      '月次エグゼクティブレビュー',
      '優先枠確保（最大10面）',
      'カスタムダッシュボード',
      'イベント連動キャンペーン',
      '競合排他条項'
    ],
    recommended: true,
    highlight: true,
    buttonStyle: 'bg-amber-400 text-black hover:bg-amber-300'
  },
  {
    tier: 'MARKET LEADER',
    name: 'マーケットリーダー',
    investment: '$5M',
    period: '年間投資額',
    features: [
      'C-Level直通ライン',
      '週次戦略セッション',
      'エリア独占権',
      'データ統合API',
      'グローバル展開サポート',
      '長期価格保証'
    ],
    highlight: false,
    buttonStyle: 'bg-amber-400 text-black hover:bg-amber-300'
  }
];

export default function PartnershipTiers() {
  return (
    <section id="partnership" className="relative bg-white py-32">
      <div className="max-w-[1400px] mx-auto px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="mb-16"
        >
          <span className="text-black text-xs tracking-[0.2em] uppercase font-semibold">
            Partnership Tiers
          </span>
          <h2 className="text-4xl md:text-5xl font-black text-black mt-4">
            ビルボード投資規模に応じた
            <br />
            <span className="text-amber-500">戦略的パートナーシップ</span>プラン
          </h2>
          <p className="text-gray-600 text-lg mt-6 max-w-3xl">
            ラスベガスの屋外広告メディア資産への投資規模に応じて、
            最適なパートナーシッププランをご提案します。
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {tiers.map((tier, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className={`relative rounded-2xl border p-10 transition-all duration-300 hover:shadow-2xl ${
                tier.highlight 
                  ? 'border-amber-400 shadow-lg scale-105' 
                  : 'border-gray-200 hover:border-gray-300'
              }`}
            >
              {tier.recommended && (
                <div className="absolute -top-4 left-1/2 -translate-x-1/2">
                  <span className="px-4 py-1.5 bg-amber-400 text-black text-xs font-semibold rounded-full whitespace-nowrap">
                    RECOMMENDED
                  </span>
                </div>
              )}

              <div className="mb-8">
                <span className="text-gray-400 text-xs tracking-[0.15em] uppercase">
                  {tier.tier}
                </span>
                <h3 className="text-2xl font-bold text-black mt-2">{tier.name}</h3>
              </div>

              <div className="mb-8">
                <span className="text-5xl font-black text-black">{tier.investment}</span>
                <p className="text-gray-500 text-sm mt-2">{tier.period}</p>
              </div>

              <ul className="space-y-4 mb-10">
                {tier.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-start gap-3">
                    <i className="ri-check-line text-amber-500 mt-0.5"></i>
                    <span className="text-gray-700 text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <a
                href="#inquiry"
                onClick={(e) => {
                  e.preventDefault();
                  document.getElementById('inquiry')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`block w-full py-4 text-center text-sm font-semibold rounded-lg transition-all cursor-pointer whitespace-nowrap ${tier.buttonStyle}`}
              >
                詳細を問い合わせる
              </a>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-center text-gray-500 text-sm mt-12"
        >
          ※上記は標準プランです。貴社の戦略目標に応じたカスタムプランもご提案可能です。
        </motion.p>
      </div>
    </section>
  );
}
